/* Existing recently-viewed rail; its progress is unrelated to delivery. */
(() => {
  'use strict';
  const mount = (page) => {
    const rail = page.querySelector('[data-cart-recent-rail]');
    if (!rail) return;
    const progress = page.querySelector('[data-cart-recent-progress]');
    const previous = page.querySelector('[data-cart-recent-scroll="prev"]');
    const next = page.querySelector('[data-cart-recent-scroll="next"]');
    const update = () => {
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const ratio = max ? rail.scrollLeft / max : 0;
      if (progress) progress.style.width = `${Math.max(0, Math.min(1, ratio)) * 100}%`;
      if (previous) previous.disabled = rail.scrollLeft < 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    };
    page.addEventListener('click', (event) => {
      const control = event.target.closest?.('[data-cart-recent-scroll]');
      if (!control || !page.contains(control)) return;
      const card = rail.querySelector('.cp-recent__card');
      rail.scrollBy({ left: (control.dataset.cartRecentScroll === 'next' ? 1 : -1) * ((card?.getBoundingClientRect().width || 260) + 26), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  window.PFCartPageCarousel = Object.freeze({ mount });
})();
